import { useTranslation } from "@i18n/hooks";
import type { PaginationProps } from "./pagination.types";
import { Button } from "../button";

export const Pagination = ({ hasNext, loadNext, hasPrevious, loadPrevious }: PaginationProps) => {
	const { t } = useTranslation("common");
	const hasNextAndPreviousSet = hasNext !== undefined && hasPrevious !== undefined;

	if (!hasNextAndPreviousSet) {
		if (!hasNext) return null;
		return (
			<div className="flex pt-4 justify-content-center">
				<Button label={t("actions.loadMore")} onClick={loadNext} />
			</div>
		);
	}

	return (
		<div className="flex pt-4 justify-content-center">
			<Button label={t("actions.back")} onClick={loadPrevious} />
			<Button label={t("actions.next")} onClick={loadNext} />
		</div>
	);
};
